import React from "react";
import PropTypes from "prop-types";

// import deep-equal
import equal from "deep-equal";

// import store
import { connect } from "react-redux";

// import store actions
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setArticle,
  togglePreloader,
} from "../../store/actions";

// import constants
import { APP_TOKEN } from "../../helpers/constants";

// import services

// import utilities
import { isUnauthenticatedRequest } from "../../helpers/utilities";
import { getOpportunities } from "../../services/opportunityService";
import SlideArticle from "../../components/custom/articles/SlideArticle";
import Banner from "../../components/common/Banner";
import Leading from "../../components/common/Leading";
import Section from "../../components/common/Section";
import ListArticle from "../../components/custom/articles/ListArticle";
import FilterArticle from "../../components/custom/articles/FilterArticle";

class Articles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    try {
      this.props.onPreloaderToggled(true, "Chargement des opportunités");
      if (!localStorage.getItem(APP_TOKEN)) {
        this.props.onAppTokenAsked(true);
      } else {
        this.onGetArticles();
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate(prevProps) {
    try {
      //Check props
      if (!equal(prevProps, this.props)) {
        if (this.props.tokenRetrieved && localStorage.getItem(APP_TOKEN)) {
          this.props.onAppTokenRetrieved(false);
          this.onGetArticles();
        } else if (this.props.tokenFailed) {
          this.props.onPreloaderToggled(false, "");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Get articles.
   *
   */
  onGetArticles() {
    getOpportunities()
      .then((response) => {
        if (response && response.data) {
          this.props.onSetArticles(response.data);
          this.props.onPreloaderToggled(false, "");
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          this.props.onPreloaderToggled(false, "");
          console.error(response, "GET ARTICLES ERROR");
        }
      })
      .catch((error) => {
        this.props.onPreloaderToggled(false, "");
        console.error(error, "GET ARTICLES ERROR");
      });
  }

  render() {
    const { articles, isPreloader } = this.props;

    return (
      <React.Fragment>
        <div id="articles" className={`${isPreloader ? "d-none" : "d-block"}`}>
          {/* Banner */}
          <Banner bannerId="opportunities-banner">
            <Leading title="Les Articles" />
          </Banner>

          {/* Articles */}
          <Section
            // subtitle="À la Une"
            sectionId="opportunities-articles"
            sectionClasses="opportunities-articles py-5"
          >
            <div className="row">
              {articles.length > 0 ? (
                <div className="col-lg-12">
                  <SlideArticle items={articles.slice(0, 10)} />
                </div>
              ) : null}
            </div>
          </Section>

          <div className="ads">
            <div className="leaderboard center-box">PUB MOYENNE ICI</div>
          </div>

          <Section
            subtitle=""
            sectionId="articles-alls"
            sectionClasses="articles-alls py-5"
            sectionInnerClasses=""
          >
            {articles.length > 0 ? (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 mt-2 articles-filters">
                    <FilterArticle />
                  </div>
                  <div className="col-lg-12">
                    <ListArticle items={articles} listerClasses="g-3" />
                  </div>
                </div>
              </div>
            ) : (
              <div className="empty-list text-center">
                <p className="mb-0 p-2">
                  La liste de nos articles, à ne pas rater, bientôt disponible.
                </p>
              </div>
            )}
          </Section>
        </div>
      </React.Fragment>
    );
  }
}
Articles.propTypes = {
  articles: PropTypes.object,
  onSetArticles: PropTypes.func,
};
const mapStateToProps = (state) => ({
  articles: state.articles,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});
const mapDispatchToProps = (dispatch) => ({
  onSetArticles: (data) => dispatch(setArticle(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Articles);
